/* RESPONSIBLE TEAM: team-phone */

export type FinVoiceRunbookOptions = {
  value: FinVoiceRunbook;
  text: string;
};

export type FinVoiceRunbook =
  | 'none'
  | 'card_reader_troubleshooting'
  | 'flex_terminal_card_reader'
  | 'damaged_card_reader'
  | 'identify_device_models'
  | 'insert_only_flex_terminal'
  | 'nfc_only_flex_terminal'
  | 'swipe_only_flex_terminal'
  | 'elo_terminal_card_reader_issue'
  | 'insert_only_elo_terminal'
  | 'swipe_only_elo_terminal'
  | 'network_offline'
  | 'nfc_only_elo_terminal'
  | 'dual_card_reader_setup_not_working_flex_terminal'
  | 'dual_card_reader_setup_not_working_elo_terminal'
  | 'all_functions_not_working_elo_terminal'
  | 'all_functions_not_working_flex_terminal'
  | 'elo_dynamag_msr_not_working'
  | 'card_reader_not_working_general_troubleshooting';

export const FIN_VOICE_RUNBOOK_OPTIONS: FinVoiceRunbookOptions[] = [
  // General options (non-terminal specific)
  { value: 'none', text: 'ai-agent.voice-playground.settings.runbook-none' },
  {
    value: 'card_reader_not_working_general_troubleshooting',
    text: 'ai-agent.voice-playground.settings.runbook-card-reader-not-working-general-troubleshooting',
  },
  {
    value: 'card_reader_troubleshooting',
    text: 'ai-agent.voice-playground.settings.runbook-card-reader-troubleshooting',
  },
  {
    value: 'damaged_card_reader',
    text: 'ai-agent.voice-playground.settings.runbook-damaged-card-reader',
  },
  {
    value: 'identify_device_models',
    text: 'ai-agent.voice-playground.settings.runbook-identify-device-models',
  },
  {
    value: 'network_offline',
    text: 'ai-agent.voice-playground.settings.runbook-network-offline',
  },
  // Flex Terminal options
  {
    value: 'flex_terminal_card_reader',
    text: 'ai-agent.voice-playground.settings.runbook-flex-terminal-card-reader',
  },
  {
    value: 'insert_only_flex_terminal',
    text: 'ai-agent.voice-playground.settings.runbook-insert-only-flex-terminal',
  },
  {
    value: 'swipe_only_flex_terminal',
    text: 'ai-agent.voice-playground.settings.runbook-swipe-only-flex-terminal',
  },
  {
    value: 'nfc_only_flex_terminal',
    text: 'ai-agent.voice-playground.settings.runbook-nfc-only-flex-terminal',
  },
  {
    value: 'dual_card_reader_setup_not_working_flex_terminal',
    text: 'ai-agent.voice-playground.settings.runbook-dual-card-reader-setup-not-working-flex-terminal',
  },
  {
    value: 'all_functions_not_working_flex_terminal',
    text: 'ai-agent.voice-playground.settings.runbook-all-functions-not-working-flex-terminal',
  },
  // Elo Terminal options
  {
    value: 'elo_terminal_card_reader_issue',
    text: 'ai-agent.voice-playground.settings.runbook-elo-terminal-card-reader-issue',
  },
  {
    value: 'swipe_only_elo_terminal',
    text: 'ai-agent.voice-playground.settings.runbook-swipe-only-elo-terminal',
  },
  {
    value: 'insert_only_elo_terminal',
    text: 'ai-agent.voice-playground.settings.runbook-insert-only-elo-terminal',
  },
  {
    value: 'nfc_only_elo_terminal',
    text: 'ai-agent.voice-playground.settings.runbook-nfc-only-elo-terminal',
  },
  {
    value: 'dual_card_reader_setup_not_working_elo_terminal',
    text: 'ai-agent.voice-playground.settings.runbook-dual-card-reader-setup-not-working-elo-terminal',
  },
  {
    value: 'all_functions_not_working_elo_terminal',
    text: 'ai-agent.voice-playground.settings.runbook-all-functions-not-working-elo-terminal',
  },
  {
    value: 'elo_dynamag_msr_not_working',
    text: 'ai-agent.voice-playground.settings.runbook-elo-dynamag-msr-not-working',
  },
];

export interface FinVoiceRunbookGroup {
  heading?: string;
  items: FinVoiceRunbookOptions[];
}

export const FIN_VOICE_RUNBOOK_GROUPED_OPTIONS: FinVoiceRunbookGroup[] = [
  // General options (no heading)
  {
    items: [
      { value: 'none', text: 'ai-agent.voice-playground.settings.runbook-none' },
      {
        value: 'card_reader_not_working_general_troubleshooting',
        text: 'ai-agent.voice-playground.settings.runbook-card-reader-not-working-general-troubleshooting',
      },
      {
        value: 'card_reader_troubleshooting',
        text: 'ai-agent.voice-playground.settings.runbook-card-reader-troubleshooting',
      },
      {
        value: 'damaged_card_reader',
        text: 'ai-agent.voice-playground.settings.runbook-damaged-card-reader',
      },
      {
        value: 'identify_device_models',
        text: 'ai-agent.voice-playground.settings.runbook-identify-device-models',
      },
      {
        value: 'network_offline',
        text: 'ai-agent.voice-playground.settings.runbook-network-offline',
      },
    ],
  },
  // Flex Terminal options
  {
    heading: 'ai-agent.voice-playground.settings.runbook-group-flex-terminal',
    items: [
      {
        value: 'flex_terminal_card_reader',
        text: 'ai-agent.voice-playground.settings.runbook-flex-terminal-card-reader',
      },
      {
        value: 'all_functions_not_working_flex_terminal',
        text: 'ai-agent.voice-playground.settings.runbook-all-functions-not-working-flex-terminal',
      },
      {
        value: 'insert_only_flex_terminal',
        text: 'ai-agent.voice-playground.settings.runbook-insert-only-flex-terminal',
      },
      {
        value: 'swipe_only_flex_terminal',
        text: 'ai-agent.voice-playground.settings.runbook-swipe-only-flex-terminal',
      },
      {
        value: 'nfc_only_flex_terminal',
        text: 'ai-agent.voice-playground.settings.runbook-nfc-only-flex-terminal',
      },
      {
        value: 'dual_card_reader_setup_not_working_flex_terminal',
        text: 'ai-agent.voice-playground.settings.runbook-dual-card-reader-setup-not-working-flex-terminal',
      },
    ],
  },
  // Elo Terminal options
  {
    heading: 'ai-agent.voice-playground.settings.runbook-group-elo-terminal',
    items: [
      {
        value: 'elo_terminal_card_reader_issue',
        text: 'ai-agent.voice-playground.settings.runbook-elo-terminal-card-reader-issue',
      },
      {
        value: 'all_functions_not_working_elo_terminal',
        text: 'ai-agent.voice-playground.settings.runbook-all-functions-not-working-elo-terminal',
      },
      {
        value: 'swipe_only_elo_terminal',
        text: 'ai-agent.voice-playground.settings.runbook-swipe-only-elo-terminal',
      },
      {
        value: 'insert_only_elo_terminal',
        text: 'ai-agent.voice-playground.settings.runbook-insert-only-elo-terminal',
      },
      {
        value: 'nfc_only_elo_terminal',
        text: 'ai-agent.voice-playground.settings.runbook-nfc-only-elo-terminal',
      },
      {
        value: 'dual_card_reader_setup_not_working_elo_terminal',
        text: 'ai-agent.voice-playground.settings.runbook-dual-card-reader-setup-not-working-elo-terminal',
      },
      {
        value: 'elo_dynamag_msr_not_working',
        text: 'ai-agent.voice-playground.settings.runbook-elo-dynamag-msr-not-working',
      },
    ],
  },
];
